<div class="indicators-bar">
    <div class="indicator-item">
        <i class="custom-icon-2 uf-icon"></i>
        <div class="indicator-text">
            <span class="indicator-title-1"><strong>UF</strong></span>
            <span class="indicator-mount-1">${{ufToday?.uf | number: '1.0-2'}}</span>
            <span class="indicator-date">{{ufToday?.date | date: 'dd-MM-yyyy'}}</span>
        </div>
    </div>

    <div class="indicator-divider"></div>

    <div class="indicator-item">
        <i class="custom-icon-2 ipc-icon"></i>
        <div class="indicator-text">
            <span class="indicator-title-1"><strong>IPC</strong></span>
            <span class="indicator-mount-1">{{ipcToday?.ipc | number: '1.0-2'}}%</span>
            <span class="indicator-date">{{ipcToday?.date | date: 'MM-yyyy'}}</span>
        </div>
    </div>

    <div class="indicator-divider"></div>

    <div class="indicator-item">
        <i class="custom-icon-2 dolar-icon"></i>
        <div class="indicator-text">
            <span class="indicator-title-1"><strong>Dólar</strong></span>
            <span class="indicator-mount-1">${{dolarToday?.dollar | number: '1.0-2'}}</span>
            <span class="indicator-date">{{dolarToday?.date | date: 'dd-MM-yyyy'}}</span>
        </div>
    </div>

    <div class="indicator-divider"></div>

    <div class="indicator-item">
        <i class="custom-icon-2 euro-icon"></i>
        <div class="indicator-text">
            <span class="indicator-title-1"><strong>Euro</strong></span>
            <span class="indicator-mount-1">${{euroToday?.euro | number: '1.0-2'}}</span>
            <span class="indicator-date">{{euroToday?.date | date: 'dd-MM-yyyy'}}</span>
        </div>
    </div>

    <div class="indicator-divider"></div>

    <div class="indicator-item">
        <i class="custom-icon-2 utm-icon"></i>
        <div class="indicator-text">
            <span class="indicator-title-1"><strong>UTM</strong></span>
            <span class="indicator-mount-1">${{utmToday?.utm | number: '1.0-2'}}</span>
            <span class="indicator-date">{{utmToday?.date | date: 'MM-yyyy'}}</span>
        </div>
    </div>
</div>
